/* T-CALORIES: dog calorie calculator. Vanilla, no libraries. RER = 70 x kg^0.75; range = RER x life-stage factor x activity band. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cal]');
  if (!root) return;
  var form = root.querySelector('[data-cal-form]');
  var $ = function (s) { return root.querySelector(s); };
  var out = $('[data-cal-out]'), empty = $('[data-cal-empty]'), resultBox = $('[data-cal-result]');
  var LB = 0.45359237, submitted = false;

  function checked(name) { return form.querySelector('input[name="' + name + '"]:checked'); }
  function r5(n) { return Math.round(n / 5) * 5; }
  function fmt(n) { return String(r5(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(el) { var v = parseFloat(String(el.value).replace(',', '.')); return isFinite(v) ? v : NaN; }
  function err(name, msg) {
    var p = root.querySelector('[data-cal-err="' + name + '"]');
    var input = form.elements[name];
    if (!p) return;
    p.hidden = !msg; p.textContent = msg || '';
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  var lastUnit = 'kg';
  function setUnits() {
    var u = checked('units').value;
    if (u !== lastUnit) {
      ['weight', 'ideal'].forEach(function (n) {
        var v = num(form.elements[n]);
        if (isFinite(v)) form.elements[n].value = (u === 'lb' ? v / LB : v * LB).toFixed(1);
      });
      lastUnit = u;
    }
    root.querySelectorAll('[data-cal-unit]').forEach(function (n) { n.textContent = u; });
  }

  function calc(focusResult) {
    var u = checked('units').value, k = u === 'lb' ? LB : 1;
    var wEl = form.elements.weight, iEl = form.elements.ideal;
    var w = num(wEl) * k, ideal = iEl.value.trim() === '' ? NaN : num(iEl) * k;
    var min = 0.5, max = 100, ok = true;
    err('weight', ''); err('ideal', '');
    if (!(w >= min && w <= max)) { err('weight', 'Enter a weight between ' + (u === 'lb' ? '1 and 220 lb.' : '0.5 and 100 kg.')); ok = false; }
    if (iEl.value.trim() !== '' && !(ideal >= min && ideal <= max)) { err('ideal', 'Enter an ideal weight between ' + (u === 'lb' ? '1 and 220 lb.' : '0.5 and 100 kg.')); ok = false; }
    if (!ok) { out.hidden = true; empty.hidden = false; return; }

    var stage = checked('stage'), act = checked('activity');
    var factor = parseFloat(stage.dataset.factor), lo = parseFloat(act.dataset.lo), hi = parseFloat(act.dataset.hi);
    var puppy = stage.value.indexOf('puppy') === 0;
    var base = isNaN(ideal) || puppy ? w : ideal;
    var rer = 70 * Math.pow(base, 0.75);
    var show = function (kg) { return u === 'lb' ? (kg / LB).toFixed(1) + ' lb' : kg.toFixed(1) + ' kg'; };

    $('[data-cal-lo]').textContent = fmt(rer * factor * lo);
    $('[data-cal-hi]').textContent = fmt(rer * factor * hi);
    $('[data-cal-rer]').textContent = fmt(rer);
    $('[data-cal-factor]').textContent = factor.toFixed(1) + ' × ' + (lo + '–' + hi) + ' activity';
    $('[data-cal-used]').textContent = show(base);
    $('[data-cal-basis]').textContent = puppy ? 'Built on your puppy’s weight today.' : (isNaN(ideal) ? 'Built on today’s weight.' : 'Built on the ideal weight, which is what a dog at a body condition of 4 to 5 should eat for.');

    var loss = !puppy && !isNaN(ideal) && w > ideal * 1.05;
    var gain = !puppy && !isNaN(ideal) && ideal > w * 1.05;
    $('[data-cal-loss]').hidden = !loss;
    $('[data-cal-gain]').hidden = !gain;
    $('[data-cal-pup]').hidden = !puppy;
    if (loss) { $('[data-cal-wlo]').textContent = fmt(rer); $('[data-cal-whi]').textContent = fmt(rer * 1.1); }

    empty.hidden = true; out.hidden = false;
    if (focusResult) { resultBox.focus({ preventScroll: true }); if (window.matchMedia('(max-width:899px)').matches) resultBox.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); submitted = true; calc(true); });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'units') setUnits();
    if (submitted) calc(false);
  });
  form.addEventListener('input', function () { if (submitted) calc(false); });
  setUnits();
})();
